import PropTypes from 'prop-types';
import React from 'react';
import { AlertSuccess } from '@bibliocommons/deprecated-base-alerts';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import '../styles/CatalogueResultItemAlert.scss';

class CatalogueResultItemAlert extends React.PureComponent {
  componentDidMount() {
    if (this.props.isFocusOnUpdate) {
      if (this._itemAddedMessage) {
        this._itemAddedMessage.focus();
      }
    }
  }

  componentDidUpdate() {
    if (this.props.isFocusOnUpdate) {
      if (this._itemAddedMessage) {
        this._itemAddedMessage.focus();
      }
    }
    return null;
  }

  render() {
    const { label } = this.props;

    return (
      <span className="cp-catalogue-result-item-alert" tabIndex="-1" ref={el => (this._itemAddedMessage = el)}>
        <ScreenReaderMessage>{label}</ScreenReaderMessage>
        <span aria-hidden="true">
          <AlertSuccess>{label}</AlertSuccess>
        </span>
      </span>
    );
  }
}

CatalogueResultItemAlert.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  isFocusOnUpdate: PropTypes.bool
};

export default CatalogueResultItemAlert;
